/**
 * @generated SignedSource<<4ac322a131e9c1f57a6d95a9c326799c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Sidebar_query$data = {
  readonly me: {
    readonly totalDocumentsByStatus: number | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "Sidebar_query";
};
export type Sidebar_query$key = {
  readonly " $data"?: Sidebar_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"Sidebar_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Sidebar_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Candidate",
      "kind": "LinkedField",
      "name": "me",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalDocumentsByStatus",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "d536bf53ca05e5cce527564484e28eda";

export default node;
